import { TShopOrderItemContext } from '@x/ecommerce/shop-client';

export class WishlistAddToProductIds {
  static readonly type = '[Wishlist] Add To Product Ids';
  constructor(
    public productId: number,
    public context?: TShopOrderItemContext,
  ) {}
}

export class WishlistRemoveFromProductIds {
  static readonly type = '[Wishlist] Remove from Product Ids';
  constructor(public productId: number) {}
}

export class WishlistClear {
  static readonly type = '[Wishlist] Clear';
}

export class WishlistTempItem {
  static readonly type = '[Wishlist] Add temp item';
  constructor(public productId: number) {}
}

export class WishlistAddActionToQueue {
  static readonly type = '[Wishlist] Add Action To Queue';
  constructor(public action: WishlistAddToProductIds | WishlistRemoveFromProductIds) {}
}
